import { render } from "./MyErid.vue?vue&type=template&id=646bfaec"
import script from "./MyErid.vue?vue&type=script&lang=js"
export * from "./MyErid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__